import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.scss'

const TabSelector = ({ options, onSelect, active }) => {
  return (
    <div className="tab-selector">
      <For each="option" of={options}>
        <button
          key={option}
          className={classNames('tab-selector__button', {
            'tab-selector__button--active': active === option,
          })}
          onClick={() => onSelect(option)}
        >
          {option}
        </button>
      </For>
    </div>
  )
}

TabSelector.defaultProps = {
  options: [],
  onSelect: () => {},
  active: '',
}

TabSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
}

export default TabSelector
